<script>
import {Link} from "@inertiajs/vue3";
export default {
	components: {
		Link
	},
	props : {
		active : {
			type : Boolean,
			default: false
		},
		url : {
			type: String,
			required: true
		}
	},
	methods: {
		closeMobileMenu(event) {
			$(document).trigger('wwdev.closeMobileMenu')
		}
	}
}
</script>
<template>
	<li :class="{'active': active }">
		<Link :class="{'active': active }" @click="closeMobileMenu" :href="url">
			<template v-if="$slots.icon">
				<slot name="icon" />
				<span class="hide-menu"><slot name="label"/></span>
			</template>

			<template v-if="!$slots.icon">
				<slot name="label"/>
			</template>
		</Link>
	</li>
</template>